import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    meta: {
        footer: {
            // style: {
            //     textAlign: 'left',
            //     fontWeight: 'normal',
            // },
            data: [
                {
                    key: 0,
                    value: '',
                },
                {
                    key: 1,
                    value: '',
                },
            ],
        },
    },
};

const getters = {
    meta: state => state.meta,

    footerData: state => state.meta.footer.data,
};

const mutations = {
    setMeta(state, data) {
        state.meta = data;
    },
};

const actions = {
    async getMeta({ commit, dispatch }) {
        const url = Laroute.route('franchise.custom.receipt.meta');

        startLoading(dispatch, 'fetch-meta');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'fetch-meta');

            if (!_.isNull(data[0]) && !_.isEmpty(data[0].meta)) {
                commit('setMeta', data[0].meta);
            }
        } catch (e) {
            endLoading(dispatch, 'fetch-meta');
            throw e;
        }
    },

    async saveMeta({ dispatch, state }) {
        const url = Laroute.route('franchise.custom.receipt.save');

        startLoading(dispatch, 'save-meta');

        try {
            await axios.post(url, state.meta);
            endLoading(dispatch, 'save-meta');
        } catch (e) {
            endLoading(dispatch, 'fetch-meta');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/custom-receipt.js